<template>
  <header>
    <nav id="nav-top" class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <router-link :to="{ name: 'Home'}" class="navbar-item">
          <h1 class="navbar-item" itemprop="logo">
            <img :src="logo" :alt="title" class="logo">
          </h1>
        </router-link>
        <a role="button" class="navbar-burger burger" v-bind:class="{ 'is-active': headerMenuState }"
          v-on:click="menuToggle()" aria-label="menu" aria-expanded="false" data-target="headerNavbarMenu">
          <!-- <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span> -->
        </a>
      </div>
      <div id="headerNavbarMenu" class="navbar-menu" v-bind:class="{ 'active': headerMenuState }">
        <div class="navbar-start">
          <router-link :to="{ name: 'Materials'}" class="navbar-item">素材</router-link>
          <router-link :to="{ name: 'Posts'}" class="navbar-item">ブログ</router-link>
          <div class="form navbar-item">
            <search></search>
          </div>
        </div>
      </div>
    </nav>

  </header>

</template>
<script>
  import SETTINGS from "../../settings";
  import Search from "./Search.vue";
  import {
    mapGetters
  } from "vuex";

  export default {
    data() {
      return {
        logo: this.getImg('img/logo.svg'),
        title: SETTINGS.TITLE,
        menuActive: false,
      }
    },
    computed: {
      ...mapGetters({
        headerMenuState: "headerMenuState",
      })
    },
    methods: {
      menuToggle() {
        this.$store.dispatch("toggleHeaderMenu", {
          limit: this.limit,
          paged: this.paged
        });
        this.menuActive = !this.menuActive;
      },
    },
    components: {
      Search
      // PagesWidget
    }
  }
</script>